define([
    'edge/quoteandbind/pa/models/PASubmissionDraftDataExtension',
    'edge/quoteandbind/mfp/models/MFPSubmissionDraftDataExtension',
], (PASubmissionDraftDataExtension, MFPSubmissionDraftDataExtension) => {
    return {
        mixinLobDraftDataExtensions: (submission) => {
            if (submission && submission.draftData && submission.draftData.productCode === 'PersonalAuto') {
                submission.draftData.lobs = submission.draftData.lobs || {};
                submission.draftData.lobs.personalAuto = new PASubmissionDraftDataExtension(submission);
            }

            if (submission && submission.draftData && (submission.draftData.productCode === 'BaloiseDirectMotorfahrzeug' || submission.draftData.productCode === 'TCSCombiMotorfahrzeug' || submission.draftData.productCode === 'PartnerDirectMotorfahrzeug' || submission.draftData.productCode === 'PartnerLeasingMotorfahrzeug')) {
                submission.draftData.lobs = submission.draftData.lobs || {};
                submission.draftData.lobs.mFPLine = new MFPSubmissionDraftDataExtension(submission);
            }
        },
    };
});


// WEBPACK FOOTER //
// ./app/customer/js/src/integration/quoteandbind/PolicyLineExtensionConfiguration.js